import useSWRMutation from 'swr/mutation'

import type { AxiosError, AxiosResponse } from 'axios'

import { User } from '@/modules/users/types/User'
import { api } from '@/utils/api.ts'

interface SignInData {
  password: string
  email: string
}

export const useSignInFetcher = () => {
  const {
    trigger: postSignInData,
    isMutating: isLoading,
    error,
    data,
  } = useSWRMutation<AxiosResponse<User>, AxiosError, 'login', SignInData>('login', async (url, { arg }) => {
    const response = await api.post<User>(url, arg)
    const user = response.data

    if (!user) {
      throw new Error('Usuario inválido o no encontrado')
    }

    if (!user.profiles || user.profiles.length === 0) {
      throw new Error('Este usuario no tiene perfiles asignados')
    }

    return response
  })

  return { isLoading, error, data, postSignInData }
}
